module.exports = __webpack_public_path__ + "static/media/Montserrat-Light.f5e955ef.otf";